import { render, staticRenderFns } from "./form-qualification-gender.vue?vue&type=template&id=61efff53"
import script from "./form-qualification-gender.vue?vue&type=script&lang=js"
export * from "./form-qualification-gender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports